module.exports = __webpack_public_path__ + "img/electronic-business-plan_s.8e227f33.png";